import { useEffect } from "react";
import useAPI from "../../api/hooks/useAPI";
import { hasAnyFiltersApplied } from "../../scenes/stack/environment/filters/utils";
import TextButton from "../buttons/TextButton";
import CustomToolTip from "../CustomTooltip";

const ClearFiltersButton = ({
  appliedFilters,
  setAppliedFilters,
  onClearClick = () => {},
}) => {
  const { trackEvent } = useAPI();

  useEffect(() => {}, [appliedFilters]);

  const resetAllFilter = () => {
    resetFiltersToDefaults(appliedFilters, setAppliedFilters);
  };

  return (
    <>
      {hasAnyFiltersApplied(appliedFilters) && (
        <CustomToolTip title="Clear all currently applied filters">
          <span>
            <TextButton
              onClick={() => {
                trackEvent("The user clicked on the clear filters button");
                resetAllFilter();
                onClearClick();
              }}
              color="inherit"
              size="small"
            >
              Clear Filters
            </TextButton>
          </span>
        </CustomToolTip>
      )}
    </>
  );
};

// Export the resetAllFilter logic for reuse
export const resetFiltersToDefaults = (appliedFilters, setAppliedFilters) => {
  setAppliedFilters(
    Object.keys(appliedFilters).reduce((acc, key) => {
      if (typeof appliedFilters[key] === "string") {
        acc[key] = "";
      } else if (
        typeof appliedFilters[key] === "object" &&
        !Array.isArray(appliedFilters[key])
      ) {
        acc[key] = {};
      } else if (Array.isArray(appliedFilters[key])) {
        acc[key] = [];
      } else if (typeof appliedFilters[key] === "boolean") {
        acc[key] = false;
      }
      return acc;
    }, {})
  );
};

export default ClearFiltersButton;
